import { render, staticRenderFns } from "./TeamOverviewPage.vue?vue&type=template&id=eb589d1a&scoped=true"
import script from "./TeamOverviewPage.vue?vue&type=script&lang=js"
export * from "./TeamOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./TeamOverviewPage.vue?vue&type=style&index=0&id=eb589d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb589d1a",
  null
  
)

export default component.exports